module.exports = __webpack_public_path__ + "img/informal-leader-manipulator-4.fbf7c8bb.svg";